<script setup lang="ts">
import type { RadioCardOption } from '@/components/ui/AppRadioCard.vue'

type PromotionalCodeOption = 'none' | 'required'

const { t } = useI18n()

const isPromotionalCodeRequired = defineModel<boolean>('isPromotionalCodeRequired', { required: true })

const options = computed<(RadioCardOption & { id: PromotionalCodeOption })[]>(() => [
  {
    id: 'none',
    title: t('pages.offer.reward.promotionalCodeNone'),
    description: t('pages.offer.reward.promotionalCodeNoneDesc')
  },
  {
    id: 'required',
    title: t('pages.offer.reward.promotionalCodeRequired'),
    description: t('pages.offer.reward.promotionalCodeRequiredDesc')
  }
])

const selectedOption = computed({
  get: () => options.value.find((o) => o.id === (isPromotionalCodeRequired.value ? 'required' : 'none')),
  set: (opt: RadioCardOption & { id: PromotionalCodeOption }) => {
    isPromotionalCodeRequired.value = opt.id === 'required'
  }
})
</script>

<template>
  <Card>
    <CardHeader>
      <CardTitle>{{ t('pages.offer.reward.promotionalCodeTitle') }}</CardTitle>
      <CardDescription>{{ t('pages.offer.reward.promotionalCodeHint') }}</CardDescription>
    </CardHeader>
    <CardContent>
      <AppRadioCard v-model="selectedOption" :options="options" />
    </CardContent>
  </Card>
</template>
